import * as React from 'react'
import type { FiltersProps } from 'components/Filters/types'
import type { Option, SelectValue } from 'shared/types'
import { useI18n } from 'context/I18nProvider'
import AnimationLocales from 'components/Filters/AnimationLocales'
import Categories from 'components/Filters/Categories'
import Organizations from 'components/Filters/Organizations'
import Pathway from 'components/Filters/Pathway'
import TeachingMethods from 'components/Filters/TeachingMethods'
import Themes from 'components/Filters/Themes'
import Switch from 'components/UI/Switch'
import Button from 'components/UI/Button'

export default function TrainingFilters({
  setValue,
  values,
  getDependencyUrl,
  reset,
}: FiltersProps) {
  const { i18n } = useI18n()

  // to-review
  return (
    <div className="grid gap-y-4">
      <Categories
        name="theme.category"
        value={values?.['theme.category'] || []}
        onChange={(vals: SelectValue[]) => setValue('theme.category', vals)}
      />
      <Themes
        key={values?.['theme.category']?.map((filter: Option) => (
          typeof filter === 'object' && 'value' in filter) ? filter?.value : filter).join(',')}
        value={values?.theme || []}
        onChange={(vals: SelectValue[]) => setValue('theme', vals)}
        urlParams={`?${getDependencyUrl('theme.category', 'category')}`}
      />
      <TeachingMethods
        value={values?.teachingMethod || []}
        onChange={(vals: SelectValue[]) => setValue('teachingMethod', vals)}
      />
      <Organizations
        value={values?.['trainers.organization'] || []}
        onChange={(vals: SelectValue[]) => setValue('trainers.organization', vals)}
        draft={false}
        trainingOrganization
      />
      <AnimationLocales
        value={values?.languages || []}
        onChange={(vals: SelectValue[]) => setValue('languages', vals)}
      />
      <Pathway
        value={values?.pathway}
        onChange={(val: string) => setValue('pathway', val)}
      />
      <Switch
        checked={Boolean(values?.restricted === 'true')}
        onChange={(val: boolean) => setValue('restricted', val ? 'true' : null)}
        labelOn={i18n('catalog.filters.onnomination')}
        labelOnClassName="mr-auto text-gray-800"
      />
      <Switch
        checked={Boolean(values?.certifying === 'true')}
        onChange={(val: boolean) => setValue('certifying', val ? 'true' : null)}
        labelOn={i18n('label.certifying')}
        labelOnClassName="mr-auto text-gray-800"
      />
      <Button type="link" onClick={() => reset()}>
        {i18n('label.reset')}
      </Button>
    </div>
  )
}
